export default __webpack_public_path__ + "static/media/Montserrat-Bold.cfceaf4e.woff2";